import React, { Children } from 'react';
import { PolicyModal } from './PolicyModal';
type PrivacyPolicyModalProps = {
  onClose: () => void;
};
export const PrivacyPolicyModal = ({
  onClose
}: PrivacyPolicyModalProps) => {
  return <PolicyModal title="Privacy Policy" onClose={onClose} data-id="element-665">
      <div className="space-y-6 text-[#6B4B3E]" data-id="element-666">
        <p className="text-sm text-[#6B4B3E]/75" data-id="element-667">Last Updated: May 18, 2025</p>
        <p data-id="element-668">
          Welcome to Story Bunny AI (the "Website"), an AI-powered storytelling
          tool designed for children and their families, operated by Story Bunny
          AI LLC ("we," "us," or "our"). This Privacy Policy explains how we
          collect, use, and protect your information when you use our Website.
        </p>
        <p data-id="element-669">
          By using Story Bunny AI, you agree to the terms of this Privacy
          Policy.
        </p>
        <h3 className="text-lg font-bold mt-8" data-id="element-670">1. Information We Collect</h3>
        <p data-id="element-671">We collect the following types of information:</p>
        <div className="space-y-4 pl-6" data-id="element-672">
          <div data-id="element-673">
            <p className="font-medium" data-id="element-674">a. Account Information:</p>
            <p data-id="element-675">
              We collect personal information that you voluntarily provide when
              you create an account, such as your name and email address. When
              used by parents or guardians on behalf of their child, we may
              collect the parent's name and email address.
            </p>
          </div>
          <div data-id="element-676">
            <p className="font-medium" data-id="element-677">b. Story Data & Activity:</p>
            <p data-id="element-678">
              We collect anonymous usage data, including interactions with the
              Website, time spent, story selections, and input used to generate
              stories. This helps us improve user experience and performance.
            </p>
          </div>
          <div data-id="element-679">
            <p className="font-medium" data-id="element-680">c. Cookies & Device Data:</p>
            <p data-id="element-681">
              We use cookies and similar technologies to enhance your
              experience, track usage patterns, and analyze traffic. You can
              manage cookie preferences through your browser settings.
            </p>
          </div>
        </div>
        <h3 className="text-lg font-bold mt-8" data-id="element-682">
          2. How We Use Your Information
        </h3>
        <p data-id="element-683">We use the information we collect to:</p>
        <ul className="list-disc pl-6 space-y-2" data-id="element-684">
          <li data-id="element-685">Provide and personalize the Story Bunny AI experience</li>
          <li data-id="element-686">Improve our technology and user interface</li>
          <li data-id="element-687">
            Communicate with you about your stories or account (if applicable)
          </li>
          <li data-id="element-688">Maintain the safety and integrity of our platform</li>
        </ul>
        <h3 className="text-lg font-bold mt-8" data-id="element-689">3. Sharing Your Information</h3>
        <p data-id="element-690">
          We do not sell or rent your personal information. We may share limited
          data:
        </p>
        <ul className="list-disc pl-6 space-y-2" data-id="element-691">
          <li data-id="element-692">
            With service providers that support our operations (e.g., hosting or
            analytics)
          </li>
          <li data-id="element-693">
            If required by law or to protect the rights and safety of our users
          </li>
          <li data-id="element-694">
            With your consent, for example, if you choose to share a story
          </li>
        </ul>
        <h3 className="text-lg font-bold mt-8" data-id="element-695">4. Data Retention & Deletion</h3>
        <p data-id="element-696">
          You may request that we delete your account and associated personal
          information at any time by contacting support@storybunny.ai. We will
          process such requests within 30 days. Usage data that is anonymized
          may be retained for internal analysis.
        </p>
        <h3 className="text-lg font-bold mt-8" data-id="element-697">5. Children's Privacy</h3>
        <p data-id="element-698">
          Story Bunny AI is designed for use by children with the involvement of
          a parent or guardian. We do not knowingly collect personal information
          from children under 13 without verifiable parental consent. If you
          believe we have collected such information in error, please contact us
          immediately and we will take appropriate steps to remove it.
        </p>
        <h3 className="text-lg font-bold mt-8" data-id="element-699">
          6. Changes to This Privacy Policy
        </h3>
        <p data-id="element-700">
          We may update this policy to reflect changes in our practices or legal
          requirements. When we do, we'll revise the "Last Updated" date above.
          Continued use of the Website after changes are made indicates your
          acceptance of the updated policy.
        </p>
        <h3 className="text-lg font-bold mt-8" data-id="element-701">7. Contact Us</h3>
        <p data-id="element-702">
          If you have any questions about this Privacy Policy or our data
          practices, please contact us at:
        </p>
        <p className="mt-4" data-id="element-703">
          Story Bunny AI LLC
          <br data-id="element-704" />
          📧 support@storybunny.ai
          <br data-id="element-705" />
          🌐 www.storybunny.ai
        </p>
      </div>
    </PolicyModal>;
};